import { render, staticRenderFns } from "./SingleHeader.vue?vue&type=template&id=1008f142&scoped=true&"
import script from "./SingleHeader.vue?vue&type=script&lang=js&"
export * from "./SingleHeader.vue?vue&type=script&lang=js&"
import style0 from "./SingleHeader.vue?vue&type=style&index=0&id=1008f142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008f142",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/SingleHeader.vue
// module id = 331
// module chunks = 0